/**
 * 通用相关的埋点
 *  - 导航栏相关
 *  - 登录相关
 *  - 搜索相关
 *  - 底部相关
 *  - 侧边栏相关
 *  - 反馈页相关
 */

export default {
  /**
   * 导航栏tab展示
   * @param {*} show 展示
   */
  homepageNavigationShow({ show }) {
    this.collect('homepage_navigation_show', { show });
  },

  /**
   * 导航栏tab下拉列表展示
   * @param {*} soure 展示页面
   */
  homepagePulldownlistShow({ source }) {
    this.collect('homepage_pulldownlist_show', { source });
  },

  /**
   * 导航栏tab点击
   * @param {*} operation 导航栏tab点击上报
   * @param {*} keyword 文案关键字
   */
  homepageNavigationClick({ operation, keyword }) {
    this.collect('homepage_navigation_click', { operation, keyword });
  },

  /**
   * 登录入口展示
   * @param {*} show 展示
   */
  loginShow({ show }) {
    this.collect('login_show', { show });
  },

  /**
   * 登录点击
   * @param {*} source 点击位置
   */
  centerSigninClick({ source }) {
    this.collect('center_signin_click', { source });
  },

  /**
   * 页尾点击
   * @param {*} keyword 页尾内容点击上报
   */
  homepageFooterClick({ keyword }) {
    this.collect('homepage_footer_click', { keyword });
  },

  /**
   * 搜索按键点击
   * @param {*} action 搜索入口点击上报
   * @param {*} keyword 上报搜索关键词
   */
  homepageSearchClick({ action, keyword }) {
    this.collect('homepage_search_click', { action, keyword });
  },

  /**
   * 右侧栏 - 回到顶部
   */
  sideedgeReturnClick(key) {
    this.collect('sideedge_button_click', { click: key });
  },

  /**
   * 右侧栏 - 点击事件
   */
  sideedgeFeedbackClick(key) {
    this.collect('sideedge_button_click', { click: key });
  },

  /**
   * 右侧栏 - 展示事件
   */
  sideedgeButtonShow(key) {
    this.collect('sideedge_button_show', { show: key });
  },

  /**
   * 反馈页 - 反馈页展示
   */
  feedbackPageShow(key) {
    this.collect('feedback_page_show', { show: key });
  },

  /**
   * 反馈页 - 反馈页点击
   */
  feedbackPageClick(key) {
    this.collect('feedback_page_click', { click: key });
  },

  /**
   * 有无帮助反馈-展示
   * @param {*} show 展示
      initial|初始弹窗展示
      help|点击有帮助按键展开的弹窗
      nohelp|点击无帮助按键展开的弹窗
      blank|必填项未填写的展示
      thank|感谢反馈的展示
   * @param {*} area 有无帮助收集位置
      bottom_right | 页面右下角
      video_tool | 视频工具栏评价
      video_full | 全屏视频播放中浮窗（click仅报help/nohelp/close）
      video_window | 窗口视频播放中浮窗（click仅报help/nohelp/close）
   * @param {*} sort：当前页面内容类型
   * @param {*} type 教程ID（不报有帮助无帮助按键的点击和关闭按键的点击）
   * @param {*} series 当前页面的系列课ID（不报有帮助无帮助按键的点击和关闭按键的点击）
   */
  isHelpSubmitShow({ show, area, sort, type, series }) {
    this.collect('details_appraise_show', { show, area, sort, type, series });
  },

  /**
   * 有无帮助反馈-点击
   * @param {*} click 点击
      help|有帮助
      nohelp|无帮助
      nosug|有帮助填写框下的无建议按键
      helpsub|提交有帮助
      nohelpsub|提交无帮助
      close|按键关闭点击
   * @param {*} area 有无帮助收集位置
      bottom_right | 页面右下角
      video_tool | 视频工具栏评价
      video_full | 全屏视频播放中浮窗（click仅报help/nohelp/close）
      video_window | 窗口视频播放中浮窗（click仅报help/nohelp/close）
   * @param {*} sort：当前页面内容类型
   * @param {*} type 教程ID（不报有帮助无帮助按键的点击和关闭按键的点击）
   * @param {*} series 当前页面的系列课ID（不报有帮助无帮助按键的点击和关闭按键的点击）
   */
  isHelpSubmitClick({ click, area, sort, type, series }) {
    this.collect('details_appraise_click', { click, area, sort, type, series });
  },

  /************************WPS学堂2022埋点表************************ */
  /**
   * 【统一顶部栏】
   * 导航栏tab展示
   * @param {*} show 展示
      navigation|导航栏tab展示;
      video|技巧视频下拉页面展示;
      courses|Office基础课下拉页面展示;
      article|Office图书馆下拉页面展示;
      group|企业知识服务下拉页面展示；
      @param {*} login：是否已登录（login仅show上报navigation时上报）
      yes|已登录头像展示（已登录状态）
      no|登录入口展示（未登录状态）
   */
  navbarShow({ show, login }) {
    this.collect('nav_show', { show, login });
  },

  /**
   * 【统一顶部栏】
   * 导航栏tab点击
   * @param {*} click
   *  tab|点击的导航栏的tab或下拉列表的内容时上报
      seach|顶部栏搜索入口点击；
      seach_enter|在顶部栏搜索框输入关键词后，使用回车确认搜索
      seach_click|在顶部栏搜索框输入关键词后，点击搜索按键确认搜索
      logo|学堂logo点击;
     @param {*} keyword 文案关键字（仅click上报tab时上报）
      关键词(上报后台配置的tab文案或下拉列表内的文案）
     @param {*} page 当前页面类型（page仅click上报tab时上报）
      homepage|首页;
      video|技巧视频详情页;
      courses|基础课详情页;
      article|图书馆文章详情页（普通版+简洁版）;
      qa|问答详情页;
      other|除以上页面的其他页面
   */
  nav_click({ click, keyword, page }) {
    this.collect('nav_click', { click, keyword, page });
  },

  /**
   * @param {*} show
   * 页尾展示(页尾出现在浏览器可视区域就上报)
   */
  footer_show({ show }) {
    this.collect('footer_show', { show });
  },

  /**
   * @param {*} click
   * 上报后台配置的文案
   */
  footer_click({ click }) {
    this.collect('footer_click', { click });
  },
};
